import { render, staticRenderFns } from "./UsersPrivilegeEmployees.vue?vue&type=template&id=681ef8e2&scoped=true&"
import script from "./UsersPrivilegeEmployees.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681ef8e2",
  null
  
)

export default component.exports